export const orderMessages = {
  'order.addressTitle': '收货地址',
  'order.back': '返回',
  'order.cancel': '取消订单',
  'order.cancelFail': '取消失败',
  'order.cancelSuccess': '订单已取消',
  'order.createdAt': '下单时间',
  'order.detailTitle': '订单详情',
  'order.empty': '暂无订单',
  'order.goodsTotal': '商品总额',
  'order.itemsTitle': '商品明细',
  'order.listTitle': '我的订单',
  'order.moreItems': '等 {n} 件商品',
  'order.notFound': '订单不存在',
  'order.orderNo': '订单号',
  'order.payable': '实付金额',
  'order.shippingFee': '运费',
  'order.status.all': '全部',
  'order.total': '合计',
  // 支付相关
  'payment.title': '确认支付',
  'payment.amount': '支付金额',
  'payment.orderId': '订单号',
  'payment.method.balance': '余额支付',
  'payment.method.balanceDesc': '使用账户余额支付',
  'payment.method.wechat': '微信支付',
  'payment.method.wechatDesc': '使用微信扫码支付',
  'payment.method.alipay': '支付宝',
  'payment.method.alipayDesc': '使用支付宝扫码支付',
  'payment.confirm': '确认支付',
  'payment.cancel': '取消',
  'payment.processing': '支付处理中',
  'payment.success': '支付成功',
  'payment.successSub': '订单支付已完成',
  'payment.failed': '支付失败',
  'payment.failedSub': '请检查网络后重试',
  'payment.retry': '重新支付',
  // 退款/售后
  'refund.requestBtn': '申请退款',
  'refund.processing': '处理中…',
  'refund.confirmTitle': '确认退款',
  'refund.confirmDesc': '确认申请退款？退款将在1-3个工作日内处理',
  'refund.confirmBtn': '确认退款',
  'refund.success': '退款申请已提交',
  'refund.reason1': '商品与描述不符',
  'refund.reason2': '收到的商品有损坏',
  'refund.reason3': '买错了/不想要了',
  'refund.reason4': '商家发错货',
  'admin.order.status.refunding': '退款中',
};
